import { getAllCategories, getAllCustomers, getAllManufacturers, getAllProducts, getAllPurchaseOrders, getAllQuotes, getAllReturnOrders, getAllSaleOrders, getAllSubCategories, getAllVendors, getPurchaseOrdersOfReturnOrders, getIncompleteProducts } from "./api/pagination";
import { AllCategories, allCustomers, allManufacturers, AllProducts, allPurchaseOrders, AllQuotes, AllSaleOrders, AllSubCategories, allVendors, setAllReturnOrders } from "./store/actions/actions";
export const getStatusColor = (status) => {
  switch (status) {
    case "New":
      return "#00509d12";
    case "Draft":
      return "#F7F7F7";
    case "Issue":
      return "#FF4D4F12";
    case "Paid":
      return "#9747FF12";
    case "Po Created":
      return "#F2994A12";
    case "Shipped":
      return "#27AE6012";
    case "pending":
      return "#00509d12";
    case "completed":
      return "#27AE6012";
    case "Cancelled":
      return "#FF4D4F12";
    default:
      return "#00509d12";
  }
};
export const getOrderIDColor = (status) => {
  switch (status) {
    case "New":
      return "#00509d";
    case "pending":
      return "#00509d";
    case "completed":
      return "#27AE60";
    case "Draft":
      return "#2F2F2F";
    case "Issue":
      return "#FF4D4F";
    case "Paid":
      return "#9747FF";
    case "Po Created":
      return "#F2994A";
    case "Shipped":
      return "#27AE60";
    case "Cancelled":
      return "red";
    default:
      return "#00509d";
  }
};
export const getItemQuantity = (arr, product) => {
  let data = [...arr];
  let res = data?.find((i) => {
    if (i?.sku) {
      return i?.sku === product?.sku
    } else if (i?._id) {
      return i?._id === product?._id
    }
  });
  return res?.quantity;
};
export const findObjById = (arr, id) => {
  let obj = arr?.find((i) => i?._id === id);
  return obj;
};
// API for Paginations 
export const fetchCustomersUtil = async ({
  page = 1,
  search = "",
  pageSize = 50,
  type = "company",
  setLoading,
  dispatch,
  setTotalPages,
}) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    getAllCustomers(page, search, pageSize, type, (res) => {
      if (res.status === 200) {
        if (typeof dispatch === "function") {
          dispatch(allCustomers(res.data.data));
        }
        if (typeof setTotalPages === "function") {
          setTotalPages(res.data.pagination.totalItems);
        }
      } else {
        console.error("Failed to fetch customers:", res.message);
      }
      if (typeof setLoading === "function") setLoading(false);
    });
  } catch (error) {
    console.error("Error fetching customers:", error);
    if (typeof setLoading === "function") setLoading(false);
  }
};
export const fetchVendorsUtil = async ({
  page = 1,
  search = "",
  pageSize = 50,
  setLoading,
  dispatch,
  setTotalPages,
}) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    getAllVendors(page, search, pageSize, (res) => {
      if (res.status === 200) {
        if (typeof dispatch === "function") {
          dispatch(allVendors(res.data.data));
        }
        if (typeof setTotalPages === "function") {
          setTotalPages(res.data.pagination.totalItems);
        }
      } else {
        console.error("Failed to fetch vendors:", res.message);
      }
      if (typeof setLoading === "function") setLoading(false);
    });
  } catch (error) {
    console.error("Error fetching vendors:", error);
    if (typeof setLoading === "function") setLoading(false);
  }
};
export const fetchPOsUtil = async ({
  page = 1,
  search = "",
  pageSize = 50,
  selectedItem,
  setLoading,
  dispatch,
  setTotalPages,
}) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    getAllPurchaseOrders(page, search, pageSize, selectedItem, (res) => {
      if (res.status === 200) {
        if (typeof dispatch === "function") {
          dispatch(allPurchaseOrders(res.data.data));
        }
        if (typeof setTotalPages === "function") {
          setTotalPages(res.data.pagination.totalItems);
        }
      } else {
        console.error("Failed to fetch purchase orders:", res.message);
      }
      if (typeof setLoading === "function") setLoading(false);
    });
  } catch (error) {
    console.error("Error fetching purchase orders:", error);
    if (typeof setLoading === "function") setLoading(false);
  }
};
export const fetchMfgUtil = async ({
  page = 1,
  search = "",
  pageSize = 50,
  setLoading,
  dispatch,
  setTotalPages,
}) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    getAllManufacturers(page, search, pageSize, (res) => {
      if (res.status === 200) {
        if (typeof dispatch === "function") {
          dispatch(allManufacturers(res.data.data));
        }
        if (typeof setTotalPages === "function") {
          setTotalPages(res.data.pagination.totalItems);
        }
      } else {
        console.error("Failed to fetch manufacturers:", res.message);
      }
      if (typeof setLoading === "function") setLoading(false);
    });
  } catch (error) {
    console.error("Error fetching manufacturers:", error);
    if (typeof setLoading === "function") setLoading(false);
  }
};
export const fetchProductsUtil = async ({
  page = 1,
  search = "",
  pageSize = 50,
  status,
  setLoading,
  dispatch,
  setTotalPages,
  onSuccess,
  isComplete = null
}) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    getAllProducts(page, search, pageSize, status, (res) => {
      if (res.status === 200) {
        if (typeof dispatch === "function") {
          dispatch(AllProducts(res.data.data));
        }
        if (typeof setTotalPages === "function") {
          setTotalPages(res.data.pagination.totalItems);
        }
        if (typeof onSuccess === "function") onSuccess();
      } else {
        console.error("Failed to fetch products:", res.message);
      }
      if (typeof setLoading === "function") setLoading(false);
    }, "", isComplete);
  } catch (error) {
    console.error("Error fetching products:", error);
    if (typeof setLoading === "function") setLoading(false);
  }
};
export const fetchIncompleteProductsUtil = async ({
  page = 1,
  pageSize = 50,
  setLoading,
  dispatch,
  setTotalPages,
  onSuccess,
}) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    getIncompleteProducts(pageSize, page, (res) => {
      if (res.status === 200) {
        if (typeof dispatch === "function") {
          dispatch(AllProducts(res.data.data));
        }
        if (typeof setTotalPages === "function") {
          setTotalPages(res.data.pagination?.totalItems ?? res.data.data?.length ?? 0);
        }
        if (typeof onSuccess === "function") onSuccess();
      } else {
        console.error("Failed to fetch incomplete products:", res.message);
      }
      if (typeof setLoading === "function") setLoading(false);
    });
  } catch (error) {
    console.error("Error fetching incomplete products:", error);
    if (typeof setLoading === "function") setLoading(false);
  }
};
export const fetchQuotesUtil = async ({
  page = 1,
  search = "",
  pageSize = 50,
  status,
  setLoading,
  dispatch,
  setTotalPages,
}) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    getAllQuotes(page, search, pageSize, status, (res) => {
      if (res.status === 200) {
        dispatch(AllQuotes(res.data.data));
        setTotalPages(res.data.pagination.totalItems);
      } else {
        console.error("Failed to fetch customers:", res.message);
      }
      setLoading(false);
    });
  } catch (error) {
    console.error("Error fetching customers:", error);
    setLoading(false);
  }
};
export const fetchReturnOrdersUtil = async ({
  page = 1,
  search = "",
  pageSize = 50,
  selectedOrderStatus,
  setLoading,
  dispatch,
  setTotalPages,
}) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    getAllReturnOrders(page, search, pageSize, selectedOrderStatus, (res) => {
      if (res.status === 200) {
        dispatch(setAllReturnOrders(res.data.data));
        setTotalPages(res.data.pagination.totalItems);
      } else {
        console.error("Failed to fetch return orders:", res.message);
      }
      setLoading(false);
    });
  } catch (error) {
    console.error("Error calling getAllReturnOrders:", error);
    setLoading(false);
  }
};
export const fetchcategoriesUtil = async ({
  page = 1,
  search = "",
  pageSize = 50,
  setLoading,
  dispatch,
  setTotalPages,
}) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    getAllCategories(page, search, pageSize, (res) => {
      if (res.status === 200) {
        if (typeof dispatch === "function") {
          dispatch(AllCategories(res.data.data));
        }
        if (typeof setTotalPages === "function") {
          setTotalPages(res.data.pagination.totalItems);
        }
      } else {
        console.error("Failed to fetch categories:", res.message);
      }
      if (typeof setLoading === "function") setLoading(false);
    });
  } catch (error) {
    console.error("Error fetching categories:", error);
    if (typeof setLoading === "function") setLoading(false);
  }
};
export const fetchSubCategoriesUtil = async ({
  page = 1,
  search = "",
  pageSize = 50,
  setLoading,
  dispatch,
  setTotalPages,
}) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    getAllSubCategories(page, search, pageSize, (res) => {
      if (res.status === 200) {
        if (typeof dispatch === "function") {
          dispatch(AllSubCategories(res.data.data));
        }
        if (typeof setTotalPages === "function") {
          setTotalPages(res.data.pagination.totalItems);
        }
      } else {
        console.error("Failed to fetch subcategories:", res.message);
      }
      if (typeof setLoading === "function") setLoading(false);
    });
  } catch (error) {
    console.error("Error fetching subcategories:", error);
    if (typeof setLoading === "function") setLoading(false);
  }
};
export const fetchOrdersUtil = async ({
  startDate = "",
  endDate = "",
  critical = false,
  status = null,
  paymentStatus = null,
  page = 1,
  pageSize = 50,
  search = "",
  sort = "desc",
  setLoading,
  dispatch,
  setTotalPages,
  setCriticalOrdersCount
}) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    getAllSaleOrders(
      startDate,
      endDate,
      critical,
      status,
      paymentStatus,
      page,
      pageSize,
      search,
      sort,
      (res) => {
        if (res.status === 200) {
          if (typeof dispatch === "function") {
            dispatch(AllSaleOrders(res.data.data));
            setCriticalOrdersCount(res?.data?.criticalOrderCount ?? 0)
          }
          if (typeof setTotalPages === "function") {
            setTotalPages(res.data.pagination.totalItems);
          }
        } else {
          console.error("Failed to fetch orders:", res.message);
        }
        if (typeof setLoading === "function") setLoading(false);
      }
    );
  } catch (error) {
    console.error("Error fetching orders:", error);
    if (typeof setLoading === "function") setLoading(false);
  }
};
export const normalizePart = (sku) => {
  if (!sku) return "";
  // Convert to string & uppercase for case-insensitive match
  let normalized = sku.toString().trim().toUpperCase();
  // Always remove TMU- prefix if present
  if (normalized.startsWith("TMU-")) {
    normalized = normalized.slice(4);
  }
  // Optional: remove dashes & slashes if you want loose matching
  // normalized = normalized.replace(/[-/]/g, "");
  return normalized;
};
export default function detectCarrier(trackingNumber) {
  const cleaned = trackingNumber.trim().toUpperCase();
  const upsRegex = /^1Z[0-9A-Z]{16}$/; // UPS always starts with 1Z
  const uspsRegex = /^9\d{21}$/;       // USPS: 22 digits starting with 9
  const fedexRegex = /^\d{12}$/;       // FEDEX: exactly 12 digits
  if (upsRegex.test(cleaned)) return "UPS";
  if (uspsRegex.test(cleaned)) return "USPS";
  if (fedexRegex.test(cleaned)) return "FEDEX";
  return "UNKNOWN";
}
